var map = {
	"./ActivateAdjacentBenefit.png": 2792,
	"./AdjacentCard.png": 8460,
	"./Card.png": 9492,
	"./Coin.png": 5340,
	"./Corruption.png": 5344,
	"./Draw2Keep1.png": 4200,
	"./DrawCard.png": 9952,
	"./GainAdjacentBenefit.png": 412,
	"./Guile-v2.png": 5276,
	"./Guile.png": 8296,
	"./Item.png": 5480,
	"./ItemCard.png": 9048,
	"./Location-C.png": 7524,
	"./Location-N.png": 1640,
	"./Location-S.png": 8852,
	"./MapToken.png": 8804,
	"./Meld-1.png": 3420,
	"./Meld-2.png": 3312,
	"./Meld.png": 4560,
	"./Meteorite.png": 9136,
	"./MeteoriteBar.png": 8568,
	"./MeteoriteCard.png": 9856,
	"./Play1Card.png": 6191,
	"./Power-v2.png": 348,
	"./Power.png": 5872,
	"./Quest.png": 268,
	"./QuestCard.png": 9932,
	"./RedArrow.png": 813,
	"./Refresh.png": 7764,
	"./RescueCard.png": 5904,
	"./Star-1.png": 1544,
	"./Star-2.png": 9476,
	"./Star.png": 924,
	"./Sweep.png": 4280,
	"./Team-X.png": 9180,
	"./Team.png": 5436,
	"./Upgrade.png": 7180,
	"./WorkerBlue-v2.png": 3288,
	"./WorkerBlue.png": 6184,
	"./WorkerGreen-v2.png": 7884,
	"./WorkerGreen.png": 6620,
	"./WorkerPurple-v2.png": 7152,
	"./WorkerPurple.png": 1164,
	"./WorkerRed-v2.png": 884,
	"./WorkerRed.png": 3344,
	"./WorkerYellow-v2.png": 5200,
	"./WorkerYellow.png": 812,
	"./core-expansion.png": 9232,
	"./gc-expansion.png": 269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7356;